
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-e7c108d2&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./details.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./details.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-e7c108d2!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./details.vue"),
  /* scopeId */
  "data-v-e7c108d2",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/YourAllegroComparison/details.vue
// module id = 540
// module chunks = 2